import DateItem from './DateItem';
import moment from '../../../../utils/moment';
import React, { useMemo } from 'react';
import useStyles from './style';
import { CircularProgress } from '@mui/material';
import { useAppSelector } from 'src/hooks/redux-hooks';
import { useTranslation } from 'react-i18next';
import { weekdaysMin } from '../../../../constants/weekdays';

type CalendarDayType = {
  className?: any;
};

const CalendarDay: React.FunctionComponent<CalendarDayType> = ({ className }) => {

  const { t } = useTranslation();
  const classes = useStyles();
  const calendarData = useAppSelector((state: any) => state.calendar);

  const curDate = calendarData.date;
  const isLoading = calendarData.isLoading;

  const todayDateInWeek = useMemo(() => {
    return moment(curDate).isoWeekday() - 1;
  }, [curDate]);
  
  return (
    <div className={`${classes.calendarDay} ${className ? className : null}`}>
      <div className={classes.weekdayHeader}>
        <div className={classes.weekday}>
          <p>{t(weekdaysMin[todayDateInWeek][0].toLowerCase() + weekdaysMin[todayDateInWeek].slice(1))}</p>
        </div>
      </div>
      <div className={classes.dateWrapper}>
        {
          isLoading ? (
            <div className={classes.loadingWrapper}>
              <div className={classes.spinner}>
                <CircularProgress/>
              </div>
            </div>
          ) : null
        }
        <DateItem
          index={0}
          curDate={curDate}
          date={moment(curDate)}
        />
      </div>
    </div>
  );
};

export default CalendarDay;